// extracted by mini-css-extract-plugin
export var chevron = "pricing-calulator-module--chevron--933c3";
export var collapsibleHeader = "pricing-calulator-module--collapsibleHeader--030d7";
export var desktop = "pricing-calulator-module--desktop--b387b";
export var destination = "pricing-calulator-module--destination--70edd";
export var divider = "pricing-calulator-module--divider--3491f";
export var dropdown = "pricing-calulator-module--dropdown--8f908";
export var dropdownContainer = "pricing-calulator-module--dropdownContainer--161fa";
export var flexContainer = "pricing-calulator-module--flexContainer--1ce36";
export var forwardSlash = "pricing-calulator-module--forwardSlash--384f0";
export var headline = "pricing-calulator-module--headline--3c054";
export var icon = "pricing-calulator-module--icon--4125d";
export var input = "pricing-calulator-module--input--08671";
export var label = "pricing-calulator-module--label--8be0a";
export var maxSends = "pricing-calulator-module--maxSends--7c2c4";
export var maxSendsContainer = "pricing-calulator-module--maxSendsContainer--591b8";
export var mobile = "pricing-calulator-module--mobile--30cc3";
export var notAvailable = "pricing-calulator-module--notAvailable--6944a";
export var open = "pricing-calulator-module--open--b1cd7";
export var pricePerSend = "pricing-calulator-module--pricePerSend--fc9fc";
export var pricingCalc = "pricing-calulator-module--pricingCalc--2290d";
export var selectedLocale = "pricing-calulator-module--selectedLocale--71915";
export var smsLimit = "pricing-calulator-module--smsLimit--cca89";
export var toggle = "pricing-calulator-module--toggle--3b310";
export var toggleContainer = "pricing-calulator-module--toggleContainer--c5d96";